/**
 * retain-companion.js — NON-BLOCKING
 * - No auto-redirects
 * - Stamps has_companion cookie if cart already has the companion
 * - Adds hidden input `companion=1` to the assessment form so downstream pages know to keep it
 */
(function () {
  const COMPANION_VARIANT_ID = 51952325853517;
  const FORM_SELECTOR = '#assessment-form'; // ← change to your real form selector if different

  // If cart already has companion, set a flag cookie (non-blocking)
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(r => r.json())
    .then(cart => {
      if (cart?.items?.some(li => li.id === COMPANION_VARIANT_ID)) {
        document.cookie = "has_companion=1; path=/; max-age=2592000; SameSite=Lax";
      }
    })
    .catch(() => { /* ignore */ });

  // Attach to assessment form submit (do NOT prevent submit; we only tag the request)
  const form = document.querySelector(FORM_SELECTOR) || document.querySelector('form');
  if (!form) return;

  // Ensure companion=1 is carried forward
  if (!form.querySelector('input[name="companion"]')) {
    const hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'companion';
    hidden.value = '1';
    form.appendChild(hidden);
  }

  const markCompanion = () => {
    document.cookie = "has_companion=1; path=/; max-age=2592000; SameSite=Lax";
  };

  form.addEventListener('submit', markCompanion, { capture: true });
  // In case your UI triggers JS submit via buttons/links:
  form.querySelectorAll('[type="submit"], [data-submit], .submit, button').forEach(btn => {
    btn.addEventListener('click', markCompanion, { capture: true });
  });
})();
